export default __webpack_public_path__ + "images/Fast-Food.1f6657.jpg";